module.exports = __webpack_public_path__ + "img/eeshop.76c64965.png";